import { Card, Image, Layout } from 'antd';
import React, { useEffect } from 'react';
import { Images } from '../../../controller/Images';
import { exitFullScreen } from '../../../controller/Fullscreen';
import { getCandidateLogo } from '../../../controller/localStroageHandler';
const { Header, Content } = Layout;
const ThankyouPage = () => {
    const logo=getCandidateLogo()
  useEffect(() => {
    exitFullScreen(document);
  }, []);
  return (
    //   <Card className="w-25">
    //     <div className='d-flex flex-column justify-content-center align-items-center text-center pt-4 gap-3'>
    //     <Image src={Images.thankyou} alt="" preview={false}/>
    //     <span className='fs-5 fw-bold'>
    //       Thank You For
    //       <br /> Submitting your test{' '}
    //     </span>
    //     <p className='fs-6 opacity-50 fw-medium'>
    //       Your submission has been received. We will be contacting you soon.
    //     </p>
    //   </div>
    //   </Card>
    <Layout className='w-100 h-100'>
      <Header className='bg-white border-2 border-bottom border-color h-auto pt-2 pb-2'>
        <Image src={logo||Images.logo} alt=''  height={50} preview={false} />
      </Header>
      {/* background-image */}
      <Content className='h-100 w-100 bg-white d-flex justify-content-center align-items-center'>
        <div className='text-center'>
          <Card className=' border-0'>
            <div className='d-flex flex-column justify-content-center align-items-center text-center pt-4 gap-3'>
              <Image src={Images.thankyou} alt='' preview={false} />
              <span className='fs-3 fw-bold'>
                Thank You 
              </span>
              <p className='fs-5 opacity-50 fw-medium'>
                Your submission has been received.<br/> We will be contacting you
                soon.
              </p>
              <div className="fs-6 opacity-50 fw-medium">You Can Now Close This Tab </div>
            </div>  
          </Card>
        </div>
      </Content>
    </Layout>
  );
};

export default ThankyouPage;
